<section class="block_form">
    <div>
        <div class="row blank_li">
            <div class="col-5" [ngClass]="{'deactive': displayMyLibrary}" name="block_lib"
                (click)="selectMyLibrary(false)">Библиотека логических моделей и деревьев результатов</div>
            <div *ngIf="authenticated" class="col-5" [ngClass]="{'deactive': !displayMyLibrary}" name="block_my"
                (click)="selectMyLibrary(true)">Моя библиотека логических моделей и деревьев результатов</div>
            <div class="col-2 add_block" (click)="addForm($event)" *ngIf="toLoad <= 0 && authenticated">
              Добавить
            </div>
        </div>

        <ng-container *ngIf="toLoad <= 0; else load">
            <div class="content_block block_my lib" *ngIf="displayMyLibrary">
                <div class="row">
                    <div class="col-5 border_right">
                    <form [formGroup]="myFilterRoot">
                        <br>
                        <label class="container_checked"><img src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNyIgaGVpZ2h0PSIyMCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDE3IDIwIj4gICAgPGNpcmNsZSBjeD0iOC43NTMiIGN5PSI3LjU4OSIgcj0iNi44ODkiIHN0cm9rZT0iIzlBMjUyNSIgc3Ryb2tlLXdpZHRoPSIxLjQiLz4gICAgPGNpcmNsZSBjeD0iOC43NTMiIGN5PSI3LjU4OSIgcj0iMi44NDIiIHN0cm9rZT0iIzlBMjUyNSIgc3Ryb2tlLXdpZHRoPSIxLjQiLz4gICAgPHBhdGggc3Ryb2tlPSIjOUEyNTI1IiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBzdHJva2Utd2lkdGg9IjEuMyIgZD0iTTMuMTg4IDEyLjY0OUwuNjU4IDE2LjE5aDMuMDM2bDEuMDEyIDMuMDM2IDMuMDM1LTQuNTU0TTEzLjgxMyAxMi42NDlsMi41MyAzLjU0MWgtMy4wMzZsLTEuMDEyIDMuMDM2LTMuMDM2LTQuNTU0Ii8+PC9zdmc+"> Верифицированные практики
                            <input type="checkbox" (change)="onMyVerifiedChange()">
                            <span class="checkmark"></span>
                        </label>
                        <br>
                        <label class="container_checked">
                            <b>Тематическая группа:</b>
                            <input type="checkbox" formControlName="tg" (change)="changeMyRoot()">
                            <span class="checkmark"></span>
                        </label>
                        <ng-container *ngIf="myFilterRoot.value.tg">
                            <label *ngFor="let tg of thematicGroups" class="container_checked">{{tg.name}}({{myCounter('thematic_group', tg)}})
                                <input type="checkbox" [value]="tg.id"
                                    (change)="onMyCheckChange('tgFilters', $event)">
                                <span class="checkmark"></span>
                            </label>
                        </ng-container>
                        <br>
                        <label class="container_checked">
                            <b>Целевые группы:</b>
                            <input type="checkbox" formControlName="target" (change)="changeMyRoot()">
                            <span class="checkmark"></span>
                        </label>
                        <ng-container *ngIf="myFilterRoot.value.target">
                            <ng-container *ngFor="let target of targets">
                                <label class="container_checked" *ngIf="!target.parent_ref">{{target.name}}({{myCounter('target', target)}})
                                    <input type="checkbox" [value]="target.id" (change)="onMyCheckChange('targetFilters', $event)">
                                    <span class="checkmark"></span>
                                </label>
                                <div *ngIf="target.checkedMy">
                                    <div *ngFor="let child of targets" class="col">
                                        <div style="padding-left: 3rem;" *ngIf="child.parent_ref == target.id">
                                            <label class="container_checked">{{child.name}}({{myCounter('target', child)}})
                                                <input type="checkbox" [value]="child.id" (change)="onMyCheckChange('targetFilters', $event)">
                                                <span class="checkmark"></span>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </ng-container>
                        </ng-container>

                        <br>
                        <label class="container_checked">
                            <b>Практики:</b>
                            <input type="checkbox" formControlName="practice" (change)="changeMyRoot()">
                            <span class="checkmark"></span>
                        </label>
                        <ng-container *ngIf="myFilterRoot.value.practice">
                            <label *ngFor="let practice of practices" class="container_checked">{{practice.name}}({{myCounter('practice', practice)}})
                                <input type="checkbox" [value]="practice.id"
                                    (change)="onMyCheckChange('practiceFilters', $event)">
                                <span class="checkmark"></span>
                            </label>
                        </ng-container>

                        <br>
                        <label class="container_checked">
                            <b>Социальные результаты:</b>
                            <input type="checkbox" formControlName="outcome" (change)="changeMyRoot()">
                            <span class="checkmark"></span>
                        </label>
                        <ng-container *ngIf="myFilterRoot.value.outcome">
                            <label *ngFor="let outcome of outcomes" class="container_checked">{{outcome.name}}({{myCounter('outcome', outcome)}})
                                <input type="checkbox" [value]="outcome.id"
                                    (change)="onMyCheckChange('outcomeFilters', $event)">
                                <span class="checkmark"></span>
                            </label>
                        </ng-container>
                    </form>
                    </div>
                    <div class="col-7 block_method_search">
                        <!-- <input class="search_input" placeholder="Поиск по ключевым словам" ctype="text" name=""> -->
                        <h2>логические модели программ:</h2>
                        <div class="item_seatchMethod" *ngFor="let logicalModel of myLogicalModels">
                            <div class="name_block open_accessadd" (click)="openAddPersonal(logicalModel)"
                            [ngClass]="{'check': transport.user && (!logicalModel.createdby || logicalModel.createdby.id != transport.user.id) && logicalModel.current_user_library, 
                            'checkMy': logicalModel.createdby && transport.user && logicalModel.createdby.id == transport.user.id && logicalModel.current_user_library,
                            'uncheck': !logicalModel.current_user_library && (!logicalModel.createdby || !transport.user || logicalModel.createdby.id != transport.user.id), 
                            'uncheckMy': logicalModel.createdby && transport.user && !logicalModel.current_user_library && logicalModel.createdby.id == transport.user.id}">
                                <!-- <img src="/newpion/static/pionfront/assets/img/method_icon1.png"> -->
                                <img *ngIf="logicalModel.verification_info"
                                    src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNyIgaGVpZ2h0PSIyMCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDE3IDIwIj4gICAgPGNpcmNsZSBjeD0iOC43NTMiIGN5PSI3LjU4OSIgcj0iNi44ODkiIHN0cm9rZT0iIzlBMjUyNSIgc3Ryb2tlLXdpZHRoPSIxLjQiLz4gICAgPGNpcmNsZSBjeD0iOC43NTMiIGN5PSI3LjU4OSIgcj0iMi44NDIiIHN0cm9rZT0iIzlBMjUyNSIgc3Ryb2tlLXdpZHRoPSIxLjQiLz4gICAgPHBhdGggc3Ryb2tlPSIjOUEyNTI1IiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBzdHJva2Utd2lkdGg9IjEuMyIgZD0iTTMuMTg4IDEyLjY0OUwuNjU4IDE2LjE5aDMuMDM2bDEuMDEyIDMuMDM2IDMuMDM1LTQuNTU0TTEzLjgxMyAxMi42NDlsMi41MyAzLjU0MWgtMy4wMzZsLTEuMDEyIDMuMDM2LTMuMDM2LTQuNTU0Ii8+PC9zdmc+"><br>
                                <p>{{logicalModel.name}}</p>
                            </div>
                            <div (click)="openDetails(logicalModel)" class="more_info">
                              <p class="center"><img src="/newpion/static/pionfront/assets/img/info_mini.png">Подробнее</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="content_block block_lib" *ngIf="!displayMyLibrary">
                <div class="row">
                    <div class="col-5 border_right">
                    <form [formGroup]="filterRoot">
                        <br>
                        <label class="container_checked"><img src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNyIgaGVpZ2h0PSIyMCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDE3IDIwIj4gICAgPGNpcmNsZSBjeD0iOC43NTMiIGN5PSI3LjU4OSIgcj0iNi44ODkiIHN0cm9rZT0iIzlBMjUyNSIgc3Ryb2tlLXdpZHRoPSIxLjQiLz4gICAgPGNpcmNsZSBjeD0iOC43NTMiIGN5PSI3LjU4OSIgcj0iMi44NDIiIHN0cm9rZT0iIzlBMjUyNSIgc3Ryb2tlLXdpZHRoPSIxLjQiLz4gICAgPHBhdGggc3Ryb2tlPSIjOUEyNTI1IiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBzdHJva2Utd2lkdGg9IjEuMyIgZD0iTTMuMTg4IDEyLjY0OUwuNjU4IDE2LjE5aDMuMDM2bDEuMDEyIDMuMDM2IDMuMDM1LTQuNTU0TTEzLjgxMyAxMi42NDlsMi41MyAzLjU0MWgtMy4wMzZsLTEuMDEyIDMuMDM2LTMuMDM2LTQuNTU0Ii8+PC9zdmc+"> Верифицированные практики
                            <input type="checkbox" (change)="onVerifiedChange()">
                            <span class="checkmark"></span>
                        </label>
                        <br>
                        <label class="container_checked">
                            <b>Тематическая группа:</b>
                            <input type="checkbox" formControlName="tg" (change)="changeRoot()">
                            <span class="checkmark"></span>
                        </label>
                        <ng-container *ngIf="filterRoot.value.tg">
                            <label *ngFor="let tg of thematicGroups" class="container_checked">{{tg.name}}({{counter('thematic_group', tg)}})
                                <input type="checkbox" [value]="tg.id"
                                    (change)="onCheckChange('tgFilters', $event)">
                                <span class="checkmark"></span>
                            </label>
                        </ng-container>
                        <br>
                        <label class="container_checked">
                            <b>Целевые группы:</b>
                            <input type="checkbox" formControlName="target" (change)="changeRoot()">
                            <span class="checkmark"></span>
                        </label>
                        <ng-container *ngIf="filterRoot.value.target">
                            <ng-container *ngFor="let target of targets">
                                <label class="container_checked" *ngIf="!target.parent_ref">{{target.name}}({{counter('target', target)}})
                                    <input type="checkbox" [value]="target.id" (change)="onCheckChange('targetFilters', $event)">
                                    <span class="checkmark"></span>
                                </label>
                                <div *ngIf="target.checked">
                                    <div *ngFor="let child of targets" class="col">
                                        <div style="padding-left: 3rem;" *ngIf="child.parent_ref == target.id">
                                            <label class="container_checked">{{child.name}}({{counter('target', child)}})
                                                <input type="checkbox" [value]="child.id" (change)="onCheckChange('targetFilters', $event)">
                                                <span class="checkmark"></span>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </ng-container>
                        </ng-container>

                        <br>
                        <label class="container_checked">
                            <b>Практики:</b>
                            <input type="checkbox" formControlName="practice" (change)="changeRoot()">
                            <span class="checkmark"></span>
                        </label>
                        <ng-container *ngIf="filterRoot.value.practice">
                            <label *ngFor="let practice of practices" class="container_checked">{{practice.name}}({{counter('practice', practice)}})
                                <input type="checkbox" [value]="practice.id"
                                    (change)="onCheckChange('practiceFilters', $event)">
                                <span class="checkmark"></span>
                            </label>
                        </ng-container>

                        <br>
                        <label class="container_checked">
                            <b>Социальные результаты:</b>
                            <input type="checkbox" formControlName="outcome" (change)="changeRoot()">
                            <span class="checkmark"></span>
                        </label>
                        <ng-container *ngIf="filterRoot.value.outcome">
                            <label *ngFor="let outcome of outcomes" class="container_checked">{{outcome.name}}({{counter('outcome', outcome)}})
                                <input type="checkbox" [value]="outcome.id" (change)="onCheckChange('outcomeFilters', $event)">
                                <span class="checkmark"></span>
                            </label>
                        </ng-container>
                    </form>
                    </div>
                    <div class="col-7 block_method_search">
                        <!-- <input class="search_input" placeholder="Поиск по ключевым словам" ctype="text" name=""> -->
                        <h2>логические модели программ:</h2>
                        <div class="item_seatchMethod" *ngFor="let logicalModel of logicalModels">
                            <div class="name_block open_accessadd" (click)="openAddPersonal(logicalModel)"
                                [ngClass]="{'check': transport.user && (!logicalModel.createdby || logicalModel.createdby.id != transport.user.id) && logicalModel.current_user_library, 
                                'checkMy': logicalModel.createdby && transport.user && logicalModel.createdby.id == transport.user.id && logicalModel.current_user_library,
                                'uncheck': !logicalModel.current_user_library && (!logicalModel.createdby || !transport.user || logicalModel.createdby.id != transport.user.id), 
                                'uncheckMy': logicalModel.createdby && transport.user && !logicalModel.current_user_library && logicalModel.createdby.id == transport.user.id}">
                                <!-- <img src="/newpion/static/pionfront/assets/img/method_icon1.png"> -->
                                <img *ngIf="logicalModel.verification_info"
                                    src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNyIgaGVpZ2h0PSIyMCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDE3IDIwIj4gICAgPGNpcmNsZSBjeD0iOC43NTMiIGN5PSI3LjU4OSIgcj0iNi44ODkiIHN0cm9rZT0iIzlBMjUyNSIgc3Ryb2tlLXdpZHRoPSIxLjQiLz4gICAgPGNpcmNsZSBjeD0iOC43NTMiIGN5PSI3LjU4OSIgcj0iMi44NDIiIHN0cm9rZT0iIzlBMjUyNSIgc3Ryb2tlLXdpZHRoPSIxLjQiLz4gICAgPHBhdGggc3Ryb2tlPSIjOUEyNTI1IiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBzdHJva2Utd2lkdGg9IjEuMyIgZD0iTTMuMTg4IDEyLjY0OUwuNjU4IDE2LjE5aDMuMDM2bDEuMDEyIDMuMDM2IDMuMDM1LTQuNTU0TTEzLjgxMyAxMi42NDlsMi41MyAzLjU0MWgtMy4wMzZsLTEuMDEyIDMuMDM2LTMuMDM2LTQuNTU0Ii8+PC9zdmc+"><br>
                                <p>{{logicalModel.name}}</p>
                            </div>
                            <div (click)="openDetails(logicalModel)" class="more_info">

                                <p class="center"><img src="/newpion/static/pionfront/assets/img/info_mini.png">Подробнее</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </ng-container>
        <ng-template #load>
            <div class="content_block">
                <h4 class="center">{{status}}</h4>
            </div>
        </ng-template>
    </div>
</section>





<!-- Добавление ЛМ 1 -->
<div class="popap_kontst dark_block blue_head" *ngIf="formPage == 1">
    <div>
        <div class="head">
            <p class="close_btn">
                <img src="/newpion/static/pionfront/assets/img/close_btn.png" (click)="closeForm()">
            </p>
            <p class="center font_500">Добавить логическую модель программы</p>
        </div>
        <div class="text_block">
            <form class=" " [formGroup]="formSelectProgram">

                <p class="line_descSel">Название программы:</p>
                <select  class="big_sellect" formControlName="program">
                    <option checked disabled value="start">Выберите из списка</option>
                    <option [value]="program.id" *ngFor="let program of programs">{{program.name}}</option>
                </select>

                <button [disabled]="formSelectProgram.value.program == 'start'" class="add_button" style="width: auto; margin-bottom: 20px;" (click)="editForm($event)">Далее</button>
            </form>
        </div>
    </div>
</div>

<!-- Модерация ЛМ 3 -->
<div class="popap_kontst dark_block blue_head" *ngIf="formPage == 3">
    <div>
        <div class="head">
            <p class="close_btn">
                <img src="/newpion/static/pionfront/assets/img/close_btn.png" (click)="closeForm()">
            </p>
            <p class="center font_500">Логическая модель программы</p>
        </div>
        <div class="text_block">
            <form class="ng-untouched ng-pristine ng-invalid block_sendfor">
                <div class="midle_text">
                    <img src="/newpion/static/pionfront/assets/img/info.png">
                    <p>Логическая модель успешно добавлена. Опубликовать в общей библиотеке?</p>
                </div>
                <button class="add_button" style="width: auto;" (click)="addToAllLibrary($event)">Да</button>
                <button class="add_button" style="width: auto;" (click)="closeForm()">Нет</button>
            </form>
        </div>
    </div>
</div>

<!-- Редактирование ЛМ 2 -->
<div class="popap_kontst dark_block blue_head big_form" *ngIf="formPage == 2">
    <div>
        <div class="head">
            <p class="close_btn">
                <img src="/newpion/static/pionfront/assets/img/close_btn.png" (click)="closeForm()">
            </p>
            <p class="center font_500">{{formEditModel.value.isNew ? 'Добавление новой' : 'Редактирование'}} логической модели</p>
        </div>
        <div class="text_block">
            <form [formGroup]="formEditModel">
                <p class="line_descSel">Название программы:</p>
                <textarea class="text_item" formControlName="name"></textarea>

                <p class="line_descSel">Сроки реализации программы:</p>
                <input type="text" formControlName="period">

                <p class="line_descSel">Название организации:</p>
                <textarea class="text_item" formControlName="organization"></textarea>

                <div class="item_wDesc">
                    <p class="line_descSel" style=" margin-bottom: 0px !important;">Тематическая группа <span>(1)</span>:</p>
                    <!-- <div class="desc_item3"> Тематическая группа - нужен текст от Ольги </div> -->
                </div>              
                <select class="big_sellect" formControlName="thematic_group_ref"> 
                    <option value="" disabled>Выберите тематическую группу</option>
                    <option *ngFor="let group of thematicGroups" [value]="group.id">{{group.name}}</option>
                </select>

                <div class="item_wDesc">
                    <p class="line_descSel" style=" margin-bottom: 0px !important;">Тип практики <span>(2)</span>:</p>
                    <!-- <div class="desc_item3"> Тип практики - нужен текст от Ольги </div> -->
                </div>

                <div class="check_block">
                    <div class="row" formArrayName="practice_refs" style="text-align: left;">
                        <div class="col-md-12">
                            <label *ngFor="let practice of practices; index as i" class="container_checked"> {{practice.name}}
                                <input type="checkbox" [formControlName]="i">
                                <span class="checkmark"></span>
                            </label>
                        </div>
                    </div>
                </div>

                <div class="item_wDesc">
                    <p class="line_descSel" style=" margin-bottom: 0px !important;">Целевые группы <span>(3)</span>:</p>
                    <!-- <div _ngcontent-flw-c49="" class="desc_item3"> Целевые группы - нужен текст от Ольги </div> -->
                </div>
                <div class="block_list">

                    <div class="check_block">
                        <div class="row" formArrayName="target_refs" style="text-align: left;">
                            <div class="col-12">
                                <ng-container *ngFor="let target of targets; index as i"> 
                                    <label class="container_checked" style="text-align: left;" *ngIf="!target.parent_ref">
                                        {{target.name}}
                                        <input type="checkbox" [formControlName]="i">
                                        <span class="checkmark"></span>
                                    </label>
                                    <div *ngIf="formEditModel.value.target_refs[i] && !targets[i].parent_ref">
                                        <div *ngFor="let child of targets; index as j" class="col">
                                            <div style="padding-left: 3rem;" *ngIf="child.parent_ref == targets[i].id">
                                                <label class="container_checked" style="text-align: left;">
                                                    {{child.name}}
                                                    <input type="checkbox" [formControlName]="j">
                                                    <span class="checkmark"></span>
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </ng-container>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="item_wDesc">
                    <p class="line_descSel" style=" margin-bottom: 0px !important;">Социальный результат <span>(4)</span>:</p>
                    <!-- <div class="desc_item3"> нужен текст от Ольги </div> -->
                </div>
                <div class="check_block" style="text-align: left;">
                    <div class="row" formArrayName="outcome_refs">
                        <div class="col-md-12">
                            <label *ngFor="let outcome of outcomes; index as i" class="container_checked" style="text-align: left;"> 
                                {{outcome.name}}
                                <input type="checkbox" [formControlName]="i">
                                <span class="checkmark"></span>
                            </label>
                        </div>
                    </div>
                </div>

                <div class="block_year">
                    <p class="line_descSel">Сведения о верификации практики, в рамках которой реализовывалась программа:</p>
                    <p class="date_list">
                        Прошла верификацию в <input type="number" name="" min="1980" max="2100" formControlName="verification_info"> г.

                    </p>
                </div>

                <p class="line_descSel">Регламентированность практики:</p>
                <select  class="big_sellect" formControlName="verification_level_regularity">
                    <option value="">Выберите из списка</option>
                    <option value="Начальный">Начальный</option>
                    <option value="Базовый">Базовый</option>
                    <option value="Продвинутый">Продвинутый</option>
                </select>

                <p class="line_descSel">Обоснованность практики:</p>
                <select  class="big_sellect" formControlName="verification_level_validity">
                    <option value="">Выберите из списка</option>
                    <option value="Начальный">Начальный</option>
                    <option value="Базовый">Базовый</option>
                    <option value="Продвинутый">Продвинутый</option>
                </select>

                <p class="line_descSel">Достижение социальных результатов:</p>
                <select  class="big_sellect" formControlName="verification_level_outcome_accessibility">
                    <option value="">Выберите из списка</option>
                    <option value="Начальный">Начальный</option>
                    <option value="Базовый">Базовый</option>
                    <option value="Продвинутый">Продвинутый</option>
                </select>

                <p class="line_descSel">Обоснованность данных о социальных результатах:</p>
                <select  class="big_sellect" formControlName="verification_level_outcome_validity">
                    <option value="">Выберите из списка</option>
                    <option value="Начальный">Начальный</option>
                    <option value="Базовый">Базовый</option>
                    <option value="Продвинутый">Продвинутый</option>
                </select>

                <div class="row class_btns">
                    <div class="col-6">
                        <input type="file" style="display: none;" #model (change)="modelUpload($event)">
                        <button (click)="triggerModelFile()" 
                        [ngClass]="{'selected_file': model_file || currentModel && currentModel.model_file, 'no_file': !model_file && !(currentModel && currentModel.model_file)}">
                        Загрузить логическую модель программы</button>
                    </div>
                    <div class="col-6">
                        <input type="file" style="display: none;" #result_tree (change)="resultTreeUpload($event)">
                        <button (click)="triggerResultTreeFile()"
                        [ngClass]="{'selected_file': currentModel && currentModel.result_tree_file || result_tree_file, 'no_file': !result_tree_file && !(currentModel && currentModel.result_tree_file)}">
                            Загрузить дерево результатов </button>
                    </div>
                </div>

                <button class="add_button" style="width: auto; margin-bottom: 20px;" (click)="editProgramFormSubmit($event)" [disabled]="formEditModel.disabled || formEditModel.invalid">{{formEditModel.value.isNew ? 'Добавить' : 'Обновить'}}</button>
            </form>
        </div>
    </div>
</div>

<div class="popap_projInfo dark_block blue_head" *ngIf="displayDetails">
    <div>
        <div class="head">
            <p (click)="closeDetails()" class="close_btn"><img
                    src="/newpion/static/pionfront/assets/img/close_btn.png"></p>
            <p class="center font_500">Логическая модель программы</p>
        </div>
        <div class="text_block">
            <p>Название программы:<br><strong><span class="project_name">{{currentModel.name}}</span></strong></p>
            <p>Организация:<br><strong><span class="organization">{{currentModel.organization}}</span></strong></p>
            <p>Тематическая группа:<br><span class="font_500" *ngIf="currentModel.thematic_group_ref">
                {{currentModel.thematic_group_ref.name}}
            </span></p>
            <p>Целевая группа:<span *ngFor="let target of currentModel.target_refs"><br><span
                        class="group font_500">{{target.name}}</span></span></p>
            <p>Тип практики:<span *ngFor="let practice of currentModel.practice_refs"><br><span
                        class="type font_500">{{practice.name}}</span></span></p>
            <p class="no_bottom">Социальные результаты:</p>
            <ul class="results">
                <li *ngFor="let outcome of currentModel.outcome_refs">{{outcome.name}}</li>
            </ul>
            <p>Сроки реализации:<br><span class=" font_500 deadlines">{{currentModel.period}}</span></p>
            <p>Сведения о верификации практики, в рамках которой реализовывалась программа:<br><span
                    class="info font_500">{{currentModel.verification_info}}</span></p>
            <p class="no_bottom">Уровни доказанности:</p>
            <div class="level font_500">
                <p>Регламентированность практики: <strong>{{currentModel.verification_level_regularity}}</strong></p>
                <p>Обоснованность практики: <strong>{{currentModel.verification_level_validity}}</strong></p>
                <p>Достижение социальных результатов:
                    <strong>{{currentModel.verification_level_outcome_accessibility}}</strong></p>
                <p>Обоснованность данных о социальных результатах:
                    <strong>{{currentModel.verification_level_outcome_validity}}</strong></p>
            </div>
            <div class="row" *ngIf="currentModel.model_file && authenticated">
                <div class="col-12"><button (click)="downloadFile(currentModel.model_file)" class="add_button"><img
                            src="/newpion/static/pionfront/assets/img/cloud_save.png">Открыть логическую
                        модель</button></div>
            </div>
            <div class="row" *ngIf="currentModel.result_tree_file && authenticated">
                <div class="col-12"><button (click)="downloadFile(currentModel.result_tree_file)"
                        class="add_button"><img src="/newpion/static/pionfront/assets/img/cloud_save.png">Открыть
                        дерево результатов</button></div>
            </div>

        </div>
    </div>
</div>

<div class="popap_accessadd dark_block" *ngIf="displayAddPersonal">
    <div>
        <p (click)="closeAddPersonal()" class="close_btn"><img
                src="/newpion/static/pionfront/assets/img/close_btn.png"></p>
        <div class="text_block">
            <img src="/newpion/static/pionfront/assets/img/info.png">
            <p>Включить в личную библиотеку инструментов{{currentModel.createdby && currentModel.createdby.id == transport.user.id ? ' или редактировать' : ''}}?</p>
            <button (click)="addToLibrary()" style="width: auto;" class="add_button">Включить</button>
            <button *ngIf="currentModel.createdby && currentModel.createdby.id == transport.user.id" (click)="editFormFromLibrary($event)" style="width: auto;" class="add_button">Редактировать</button>
        </div>
    </div>
</div>
<div class="popap_accessadd dark_block" *ngIf="displayRemovePersonal">
    <div>
        <p (click)="closeAddPersonal()" class="close_btn"><img
                src="/newpion/static/pionfront/assets/img/close_btn.png"></p>
        <div class="text_block">
            <img src="/newpion/static/pionfront/assets/img/info.png">
            <p>Исключить из личной библиотеки инструментов{{currentModel.createdby && currentModel.createdby.id == transport.user.id ? ' или редактировать' : ''}}?</p>
            <button (click)="removeFromLibrary()" style="width: auto;" class="add_button">Исключить</button>
            <button *ngIf="currentModel.createdby && currentModel.createdby.id == transport.user.id" (click)="editFormFromLibrary($event)" style="width: auto;" class="add_button">Редактировать</button>
        </div>
    </div>
</div>